import { cn } from "@/lib/utils";
import { statusMeta, TONES } from "@/lib/status";

// Pílula de status com dot pulsante. Semântica: ok/warn/err/info.
export const StatusBadge = ({ status, label, pulse = true, className, size = "md", ...props }) => {
  const meta = statusMeta(status);
  const tone = TONES[meta.tone];
  const text = label ?? meta.label;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap",
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs",
        tone.bg, tone.border, tone.text, className,
      )}
      {...props}
    >
      <span className="relative flex h-1.5 w-1.5">
        {pulse && meta.tone !== "neutral" && (
          <span className={cn("absolute inline-flex h-full w-full rounded-full opacity-60 animate-pulse-dot", tone.dot)} />
        )}
        <span className={cn("relative inline-flex h-1.5 w-1.5 rounded-full", tone.dot)} />
      </span>
      {text}
    </span>
  );
};

// Ponto + rótulo simples (para legendas / cabeçalhos)
export const HealthIndicator = ({ tone = "ok", label, className }) => {
  const t = TONES[tone] || TONES.neutral;
  return (
    <span className={cn("inline-flex items-center gap-2 text-xs text-muted-foreground", className)}>
      <span className="relative flex h-2 w-2">
        <span className={cn("absolute inline-flex h-full w-full rounded-full opacity-60 animate-pulse-dot", t.dot)} />
        <span className={cn("relative inline-flex h-2 w-2 rounded-full", t.dot)} />
      </span>
      {label}
    </span>
  );
};
